//Re-renders the product section so the product's add to cart can be locked if the user now has all the available stock in their cart, or unlocked if the user had all the available stock but reduced/removed the quantity from  their cart
const rerenderProductSection = async () => {
    const productPageDiv = document.querySelector('.thb-product-detail.product');
    if (productPageDiv) {
        const sectionId = productPageDiv.dataset.sectionId;
        const pagePath = productPageDiv.dataset.pagePath;

        if (sectionId && pagePath) {
            const searchParamsStr = new URLSearchParams(document.location.search);

            const response = await fetch(`${pagePath}?section_id=${sectionId}&${searchParamsStr}`);
            if (!response.ok) { console.log(response.url); throw new Error('Network response was not ok') };
            const sectionHTML = await response.text();
            document.getElementById('shopify-section-' + sectionId).innerHTML = sectionHTML;
        }
    }
}